import {
  FaDatabase,
  FaLayerGroup,
  FaWrench,
  FaShieldAlt,
} from "@onemind-services-llc/react-icons-ng/fa";
import HeroBg from "public/marketplace-apps/hero/Hero-section-mariadb.png";

export const MARIADB_CONSTANTS = {
  HERO: {
    title: "OneMind Services — MariaDB (One-Click Application) ",
    desc: "Deploy MariaDB, a powerful open-source relational database with high performance and MySQL compatibility.",
    button: {
      label: "Try Now",
      link: "contact-us",
    },
    image: HeroBg,
  },
  INTRO: {
    title: "General Information",
    text: "MariaDB is a robust, open-source relational database management system (RDBMS) that is a fork of MySQL. It offers enhanced performance, scalability, and features while maintaining compatibility with MySQL. ",
  },
  WHY_ONEMIND: {
    title: "Deploy Effortlessly with OneMind Ease ",
    desc: [
      {
        highlight: "One-Click Installation",
        text: " One-Click Installation : Launch a fully configured and secure MariaDB instance in minutes—no need to install or manage dependencies. ",
      },
      {
        highlight: "Global Reach",
        text: " Global Reach : Deploy in any of our multiple data-center regions to keep latency low and performance high. ",
      },
      {
        highlight: "Pre‑Configured Setup",
        text: " Pre‑Configured Setup : Includes MariaDB server, default admin credentials, and optimized system settings. ",
      },
    ],
    marginTop: 0,
    btnText: "Start Now",
  },
  GET_STARTED: {
    title: "Access & Administration ",
    desc: [
      {
        text: "Once deployed, you’ll receive in your console:",
      },
      {
        text: " Username :",
        highlight: "root",
      },
      {
        text: " Password :",
        highlight: "<generated-password>",
      },
    ],
    connection: {
      text: "Access your MariaDB instance using the following command: ",
      command: "-u root -p -h <YOUR_INSTANCE_IP> ",
    },
    installation: {
      heading: "Installation Location -",
      text: "The configuration file is located in the directory",
      location: " /etc/mysql/mariadb.conf.d/ ",
    },
    ports: {
      heading: "Ports Used ",
      text: "Application, besides standard Ubuntu Ports (53/22), uses: ",
      list: ["3306 (MariaDB)  "],
    },
    note: "Note : Find the configuration file at /etc/mysql/mariadb.conf.d/ for customized tweaks or backup. ",
  },
  FEATURES: {
    items: [
      {
        icon: FaDatabase,
        title: "MySQL Compatibility",
        text: "Drop-in replacement for MySQL with enhanced features and performance.",
      },
      {
        icon: FaLayerGroup,
        title: "Storage Engines",
        text: "Supports multiple storage engines, including InnoDB, Aria, and MyRocks.",
      },
      {
        icon: FaWrench,
        title: "Advanced Features",
        text: "Offers features like JSON support, temporal data tables, and dynamic columns.",
      },
      {
        icon: FaShieldAlt,
        title: "Security Enhancements",
        text: "Includes data-at-rest encryption, user roles, and password validation plugins.",
      },
    ],
  },
  BENEFITS: {
    title: "Resilience & Scaling ",
    options: [
      {
        label: "Backups & Snapshots",
        text: "Use OneMind’s snapshot feature or integrate standard backup procedures for MariaDB data and configurations. ",
      },
      {
        label: "Security Out of the Box",
        text: "Hardened with firewall rules, TLS ready, and access control configurations. ",
      },
      {
        label: "Scalable Architecture",
        text: "Scale compute, memory, and storage; optionally integrate with replication and clustering for high availability. ",
      },
    ],
  },
  SUPPORT: {
    docsText: "MariaDb Official Docs",
    docsLink: "https://mariadb.com/docs",
  },
};
